import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	({
		type: 'error',
		title: messages.title,
		description: messages.description,
		messageId: 'servicedesk-knowledge-hub.flags.update-categories-for-article-failure',
		messageType: 'transactional',
	}) as FlagConfiguration;
